 
import React from "react";
import { PageLoader } from "../../../../../../components/PageLoader/PageLoader";
import { StandadCard } from "../../../../../../components/Cards";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { LoadState, MODULE_IDS } from "../../../../../../constants/enums";
import { useDispatchWrapper,
  useBreadcrumb,
} from "../../../../../../hooks";
import { useFormik } from "formik";
import {
  Box,
  Checkbox,
  Grid,
  Stack,
} from "@mui/material";
import {
  ControlledCustomSelect,
  CustomFormLabel,
  CustomTextField,
} from "../../../../../../components/formsComponents";

import { useNavigate } from "react-router-dom";
import { CustomDatePicker } from "../../../../../../components/formsComponents/CustomDatePicker";
import moment from "moment";
import {
  COMMON_STATUS,
} from "../../../../../../constants/constants";
import {
  addBusinesPolicyFineArtAsync,
  addLeadBusinessFineArtAsync,
  clearBusinessFineArtState,
  fetchBusinessPolicyFineArtAsync,
  fetchLeadFineArtAsync,
} from "../../../../../../redux/businessPolicy/businessPolicyFineArt/businessPolicyFineArtActions";
import {
  ILocationResponsePayload,
  LocationAutoComplete,
} from "../../../../../../components/LocationAutoComplete/LocationAutoComplete";
import {
  clearInterestedPartyState,
  fetchBrokerageIntrestedAllPartiesAsync,
} from "../../../../../../redux/InterestedParties/IntrestedPartiesActions";
import { CurrencyTextField } from "../../../../../../components/CurrencyTextField/CurrencyTextField";
import { isAlphaNumericCapital } from "../../../../../../helpers/isAlphaNumericCapital";
import { RoleBasedCustomButton } from "../../../../../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";
import { InterestedPartyCodeSearchSelect } from "../../../../../../components/AutoCompleteSearches/InterestedPartyCodeSearchSelect";
import { IBusinessPolicyInterested } from "../../../../../../redux/businessPolicy/businessPolicyInterested/businessPolicyInterested.types";
import { IBusinessPolicyFineArt } from "../../../../../../redux/businessPolicy/businessPolicyFineArt/businessPolicyFineArt.types";
import { FieldSet } from "../../../../../../components/FieldSet/FieldSet";
import { PageContainer } from "../../../../../../components/container/PageContainer";
interface EquipmentProps {
  customerId?: number;
  customerPolicyId?: number;
  /** Lead-scoped identifier. When present, the form saves/fetches by lead_id. */
  leadId?: string;
  fineArtNumber?: number;
  readOnly?: boolean;
  fromRightPanel?: boolean;
  staticStatusValue?: string;
  created_from?: string;
  onSaveSuccess: (fineArt: IBusinessPolicyFineArt) => void;
  initialData?: IBusinessPolicyFineArt;
  disableApiCalls?: boolean;
  disableSaveApi?: boolean;
}
export const FineArt: React.FC<EquipmentProps> = (props) => {
  const {
    customerId,
    customerPolicyId,
    leadId,
    fineArtNumber,
    onSaveSuccess,
    readOnly = false,
    fromRightPanel = false,
    staticStatusValue,
    created_from,
    initialData,
    disableApiCalls = false,
    disableSaveApi
  } = props;

  useBreadcrumb({
    title: "",
    items: [
    {
      to: "/policies/",
      title: "all-policies ",
    },
    {
      to: "/policies/Business%20Policy",
      title: "business",
    },
    {
      to: "/customer-overview/" + customerId,
      title: "customer",
    },
    {
      to:
        "/business-policy/" +
        customerId +
        "/schedule-tab/" +
        customerPolicyId +
        `?tab=2`,
      title: "fine-arts",
    },
    {
      title: fineArtNumber ? "edit-fine-art" : "add-fine-art",
    },
  ],
  });


  const { fineArtLoading, fineArt, error } = useSelector(
    (storeState: IStoreState) => storeState.business.fineArt
  );
  const [saveLoading, setSaveLoading] = React.useState(false);
  const dispatch = useDispatchWrapper();
  const navigate = useNavigate();

  const { values, handleChange, handleSubmit, setFieldValue, setValues } =
    useFormik({
      initialValues: initialData ? initialData : fineArt,
      validate: (values) => {},
      onSubmit: (values) => {
        if (disableSaveApi) {
          onSaveSuccess(values);
        } else {
          let statusValue = values.status;
          if (staticStatusValue) {
            statusValue = staticStatusValue;
          }
          // Lead-binder scope: save by lead_id (no customer_policy_id required).
          if (leadId) {
            setSaveLoading(true);
            dispatch(
              addLeadBusinessFineArtAsync(
                {
                  ...values,
                  status: statusValue,
                  created_from: created_from || "Fine_Art",
                },
                { leadId },
                (isSuccess, fineArt) => {
                  if (isSuccess && fineArt) {
                    window.scrollTo(0, 0);
                    onSaveSuccess(fineArt);
                  }
                  setSaveLoading(false);
                }
              )
            );
            return;
          }
          if (customerPolicyId && customerId) {
            setSaveLoading(true);
            dispatch(
              addBusinesPolicyFineArtAsync(
                {
                  ...values,
                  customer_id: customerId,
                  customer_policy_id: customerPolicyId,
                  status: statusValue,
                  created_from: created_from || "Fine_Art",
                },
                (isSuccess, fineArt) => {
                  if (isSuccess && fineArt) {
                    window.scrollTo(0, 0);
                    onSaveSuccess(fineArt);
                  }
                  setSaveLoading(false);
                }
              )
            );
          }
        }
      },
    });

  const handleAddress = (data: ILocationResponsePayload) => {
    setValues({
      ...values,
      address: data.address,
      city: data.city,
      country: data.country,
      province_or_state: data.state,
      postal_code: data.postalCode,
    });
  };

  const handleSerialNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event.target;
    const sanitizedValue = isAlphaNumericCapital(value);
    setFieldValue(name, sanitizedValue);
  };

  React.useEffect(() => {
    if (disableApiCalls || !fineArtNumber) {
      return;
    }
    if (leadId) {
      dispatch(fetchBrokerageIntrestedAllPartiesAsync());
      dispatch(fetchLeadFineArtAsync({ leadId }, fineArtNumber));
    } else if (customerPolicyId) {
      dispatch(fetchBrokerageIntrestedAllPartiesAsync());
      dispatch(
        fetchBusinessPolicyFineArtAsync(customerPolicyId, fineArtNumber)
      );
    }
  }, [customerPolicyId, leadId, fineArtNumber]);

  React.useEffect(() => {
    if (initialData && disableApiCalls) {
      return;
    }
    setValues({
      ...fineArt,
      incremental_number: fineArtNumber || null,
      effective_date: moment().format("YYYY-MM-DD"),
    });
  }, [fineArt]);

  React.useEffect(() => {
    return () => {
      dispatch(clearBusinessFineArtState());
      dispatch(clearInterestedPartyState());
    };
  }, []);

  const handleIntrestedPartyCode = (data: IBusinessPolicyInterested) => {
    if (data) {
      setValues({
        ...values,
        interest: data.interest || "",
        interested_party_code: data.interested_party_code || "",
        interested_party: data.interested_party || "",
        address: data.address || "",
        unit_or_suite: data.unit_or_suite || "",
        city: data.city || "",
        country: data.country || "",
        province_or_state: data.province_or_state || "",
        postal_code: data.postal_code || "",
      });
    }
  };

  const intrestedParities = useSelector(
    (storeState: IStoreState) =>
      storeState.borkerage.intrestedParties.intrestedParties.list
  );

  // const intrestedParitiesDropdown = React.useMemo(() => {
  //   return intrestedParities.map((item) => {
  //     return {
  //       label: item.interested_party_code,
  //       value: item.interested_party_code || "",
  //     };
  //   });
  // }, [intrestedParities]);

  return (
 <PageContainer
      title={fineArt ? "Edit fine art" : "Create fine art"}
      description="this is inner page"
    >    <PageLoader
      loading={fineArtLoading === LoadState.InProgress}
      error={error ? { message: error } : undefined}
    >
      <StandadCard
        sx={{ mt: 2 }}
        renderWithoutCard={fromRightPanel}
        heading={!fromRightPanel ? "Fine Art" : ""}
      >
        <form onSubmit={handleSubmit}>
          <FieldSet disabled={readOnly}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={1}>
                <CustomFormLabel>#</CustomFormLabel>
                <CustomTextField
                  name="incremental_number"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.incremental_number}
                  disabled
                />
              </Grid>
              <Grid item xs={12} md={2.4}>
                <CustomFormLabel>Effective Date</CustomFormLabel>
                <CustomDatePicker
                  fullWidth
                  value={values.effective_date || ""}
                  onChange={(newValue) => {
                    setFieldValue("effective_date", newValue);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.4}>
                <CustomFormLabel>Year</CustomFormLabel>
                <CustomDatePicker
                  fullWidth
                  views={["year"]}
                  inputFormat="YYYY"
                  value={values.year || ""}
                  onChange={(newValue, x, momentObject) => {
                    setFieldValue(
                      "year",
                      momentObject ? moment(momentObject).format("YYYY") : null
                    );
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3.8}>
                <CustomFormLabel>Serial Number</CustomFormLabel>
                <CustomTextField
                  name="serial_number"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.serial_number}
                  onChange={handleSerialNumberChange}
                />
              </Grid>
              <Grid item xs={12} md={2.4}>
                <CustomFormLabel>Limit ($)</CustomFormLabel>
                <CurrencyTextField
                  fullWidth
                  value={values.limit_amount}
                  onChange={(value) => {
                    setFieldValue("limit_amount", value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <CustomFormLabel>Purchase Date</CustomFormLabel>
                <CustomDatePicker
                  fullWidth
                  value={values.purchase_date || ""}
                  onChange={(newValue) => {
                    setFieldValue("purchase_date", newValue);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <InterestedPartyCodeSearchSelect
                  label="Interested Party Code"
                  value={values.interested_party_code}
                  onSelect={(value) => handleIntrestedPartyCode(value)}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <CustomFormLabel>Intersted Party</CustomFormLabel>
                <CustomTextField
                  name="interested_party"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.interested_party}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <CustomFormLabel>Interest</CustomFormLabel>
                <CustomTextField
                  name="interest"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.interest}
                  // error={errors.name ? true : false}
                  // helperText={errors.name}
                  // disabled={isUpdateLead}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <CustomFormLabel>Address</CustomFormLabel>
                <LocationAutoComplete
                  id="address"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.address}
                  onLocationChange={handleAddress}
                />
              </Grid>
              <Grid item xs={12} lg={1.5}>
                <CustomFormLabel>Unit/Suite</CustomFormLabel>
                <CustomTextField
                  id="unit_or_suite"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.unit_or_suite}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} lg={2}>
                <CustomFormLabel>City</CustomFormLabel>
                <CustomTextField
                  id="city"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.city}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={2}>
                <CustomFormLabel>State/Province</CustomFormLabel>
                <CustomTextField
                  id="province_or_state"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.province_or_state}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={1.5}>
                <CustomFormLabel>Postal Code</CustomFormLabel>
                <CustomTextField
                  id="postal_code"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.postal_code}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={2}>
                <CustomFormLabel>Country</CustomFormLabel>
                <CustomTextField
                  id="country"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  value={values.country}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomFormLabel>Description</CustomFormLabel>
                <CustomTextField
                  name="description"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  multiline
                  rows={3}
                  value={values.description}
                  // error={errors.name ? true : false}
                  // helperText={errors.name}
                  // disabled={isUpdateLead}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomFormLabel>Note</CustomFormLabel>
                <CustomTextField
                  name="note"
                  variant="outlined"
                  size="small"
                  type="text"
                  fullWidth
                  multiline
                  rows={3}
                  value={values.note}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} lg={4} sx={{ mt: 3 }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Checkbox
                    name="fine_art_submission_checkbox"
                    size="medium"
                    color="primary"
                    checked={values.fine_art_submission_checkbox === "Y"}
                    onChange={(e, checked) => {
                      setFieldValue(
                        "fine_art_submission_checkbox",
                        checked ? "Y" : "N"
                      );
                    }}
                  />
                  <CustomFormLabel sx={{ fontSize: "16px" }}>
                    Submission
                  </CustomFormLabel>
                </Stack>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} lg={4}>
                <CustomFormLabel>Status</CustomFormLabel>
                <ControlledCustomSelect
                  fullWidth
                  value={values.status}
                  name="status"
                  onChange={handleChange}
                  placeholder="Select one"
                  displayEmpty
                  options={COMMON_STATUS}
                />
              </Grid>
            </Grid>

            <Box sx={{ mt: 4 }}>
              <RoleBasedCustomButton
                moduleKey={MODULE_IDS.BUSINESS_POLICY}
                sx={{ width: "15%" }}
                disabled={saveLoading}
                variant="contained"
                type="submit"
              >
                Save
              </RoleBasedCustomButton>
            </Box>
          </FieldSet>
        </form>
      </StandadCard>
    </PageLoader>
    </PageContainer>
  );
};
